import { InitialValues } from 'forms/types';

import { BasicHealthInfoQuery } from '../../graphql/queries/BasicHealthInfo/query';
import { BasicInfoFormValues } from '../../Info/form/types';

export default (
  customer?: BasicHealthInfoQuery['customer']
): InitialValues<BasicInfoFormValues> => ({
  dateOfBirth: customer?.identityProfile.dateOfBirth,
  gender: customer?.identityProfile.gender,
  zipCode: customer?.residenceProfile.zipCode,
});
